import type {Color} from "@cm/graph-v3"
import {SeparateRgb} from "#material/nodes/converter/separate-rgb/separate-rgb"
import {GraphNode} from "@cm/graph-v3"
import {materialConnection} from "#material/nodes/base/connection/shorthand"
import type {InputMaterialConnection, OutputMaterialConnection} from "#material/sockets/definition"

export function separateRgb(v: Color | InputMaterialConnection<"color">): {
    r: OutputMaterialConnection<"float">
    g: OutputMaterialConnection<"float">
    b: OutputMaterialConnection<"float">
} {
    const node = new SeparateRgb({parameters: {inputs: {image: v instanceof GraphNode ? v : undefined}, settings: {}}})
    return {r: materialConnection(node, "r"), g: materialConnection(node, "g"), b: materialConnection(node, "b")}
}
